import { render } from "./azure-disk.vue?vue&type=template&id=2698669a&scoped=true"
import script from "./azure-disk.vue?vue&type=script&lang=js"
export * from "./azure-disk.vue?vue&type=script&lang=js"

import "./azure-disk.vue?vue&type=style&index=0&id=2698669a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2698669a"]])

export default __exports__